import { apiClient } from '@app/api';
import { useAuditReportsGetGipMetadataAdvertisers } from '@mi-front/api-v2';
import { DateTimeStr } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import { useGipFormNewApi } from './useGipFormNewApi';

/**
 * Advertisers search for the GIP form. Uses the new audit-reports API when
 * `app__gip_form_new_api` is on; otherwise the legacy logger endpoint.
 * Both queries are always mounted and gated with `enabled` (Rules of Hooks).
 */
export function useGipAdvertisersQuery(
  params: {
    from: DateTimeStr;
    to: DateTimeStr;
    stations: string[];
    search: string;
  },
  enabled: boolean,
) {
  const useNewApi = useGipFormNewApi();

  const legacy = useQuery({
    queryKey: ['gip-report-advertisers-search', params],
    queryFn: () =>
      apiClient.audit.gipFetchAdvertisers(params).then((values) => values.filter((v) => !!v)),
    enabled: !useNewApi && enabled,
    staleTime: 5 * 60 * 1000,
  });

  const neu = useAuditReportsGetGipMetadataAdvertisers(
    { search: params.search },
    {
      query: {
        enabled: useNewApi && enabled,
        staleTime: 5 * 60 * 1000,
        select: (advertisers) => advertisers.filter((v) => !!v),
      },
    },
  );

  return useNewApi ? neu : legacy;
}
